import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M16.444 18.01L10.432 12L16.444 5.98999L17.859 7.40399L13.259 12.004L17.859 16.604L16.444 18.01ZM8.14404 18H6.14404V5.99999H8.14404V18Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "FirstPage"
);
